import Controller from "@ember/controller";
import EmberObject, { action, computed } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { deepEqual } from "discourse/lib/object";
import { emailValid } from "discourse/lib/utilities";
import { i18n } from "discourse-i18n";

export default class EmailController extends Controller {
  queryParams = ["new"];
  taken = false;
  saving = false;
  error = false;
  success = false;

  /** @type {string | null | undefined} */
  oldEmail = null;

  /** @type {string | null | undefined} */
  newEmail = null;

  /** @type {string | null} */
  successMessage = null;

  @computed("newEmail")
  get newEmailEmpty() {
    return isEmpty(this.newEmail);
  }

  @computed("saving", "newEmailEmpty", "taken", "unchanged", "invalidEmail")
  get saveDisabled() {
    return (
      this.saving ||
      this.newEmailEmpty ||
      this.taken ||
      this.unchanged ||
      this.invalidEmail
    );
  }

  @computed("newEmailLower", "oldEmail")
  get unchanged() {
    return deepEqual(this.newEmailLower, this.oldEmail);
  }

  @computed("newEmail")
  get newEmailLower() {
    return this.newEmail.toLowerCase().trim();
  }

  @computed("saving", "new")
  get saveButtonText() {
    if (this.saving) {
      return i18n("saving");
    }
    if (this.new) {
      return i18n("user.add_email.add");
    }
    return i18n("user.change");
  }

  @computed("newEmail")
  get invalidEmail() {
    return !emailValid(this.newEmail);
  }

  @computed("invalidEmail", "oldEmail", "newEmail")
  get emailValidation() {
    if (this.invalidEmail && (this.oldEmail || this.newEmail)) {
      return EmberObject.create({
        failed: true,
        reason: i18n("user.email.invalid"),
      });
    }
  }

  reset() {
    this.setProperties({
      taken: false,
      saving: false,
      error: false,
      success: false,
      newEmail: null,
    });
  }

  @action
  saveEmail() {
    this.set("saving", true);

    return (
      this.new
        ? this.model.addEmail(this.newEmail)
        : this.model.changeEmail(this.newEmail)
    ).then(
      () => {
        this.set("success", true);

        if (this.model.staff) {
          this.set("successMessage", i18n("user.change_email.success_staff"));
        } else {
          if (this.currentUser.admin) {
            this.set(
              "successMessage",
              i18n("user.change_email.success_via_admin")
            );
          } else {
            this.set("successMessage", i18n("user.change_email.success"));
          }
        }
      },
      (e) => {
        this.setProperties({ error: true, saving: false });
        if (
          e.jqXHR.responseJSON &&
          e.jqXHR.responseJSON.errors &&
          e.jqXHR.responseJSON.errors[0]
        ) {
          this.set("errorMessage", e.jqXHR.responseJSON.errors[0]);
        } else {
          this.set("errorMessage", i18n("user.change_email.error"));
        }
      }
    );
  }
}
